var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    stroke: "#494D67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.352 8.663-.915-2.21L16.667 5 15 3.333 13.554 4.57l-2.256-.929-.519-1.973H9.15l-.526 2-2.204.93L5 3.333 3.333 5l1.211 1.49-.9 2.215-1.977.462v1.666l2 .547.93 2.203L3.332 15 5 16.667l1.493-1.217 2.171.894.503 1.99h1.666l.504-1.99 2.209-.914c.368.263 1.454 1.237 1.454 1.237L16.667 15 15.43 13.54l.915-2.208 1.988-.518V9.167l-1.98-.504z",
    stroke: "#494D67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.95b3c10161d1b05b0c54c29045a05372.svg";
export { ForwardRef as ReactComponent };